import { useEffect, useState, useMemo } from "react";
import { useTranslation } from "../../i18n/I18nContext";
import { PageHead } from "../../components/common";
import { MainContainer } from "../../components/organisms";
import { buildOrganizationSchema, buildWebsiteSchema } from "../../utils/seo";
import {
  LandingHero,
  LandingHowItWorks,
  LandingFeatures,
  LandingCategories,
  LandingPromBiz,
  LandingDiscovery,
  LandingTestimonials,
  LandingInsights,
} from "./landing";
import { fetchBusinesses } from "../../services/catalogService";

function toCardItem(b) {
  return {
    id: b.id,
    slug: b.slug,
    img: b.resolvedCoverImage || b.coverImage || null,
    coverImage: b.coverImage,
    cover_image_url: b.cover_image_url,
    categorySlug: b.categorySlug || b.category_slug || null,
    name: b.name || "Untitled",
    category: b.category || "",
    location: b.city || "",
    shortDescription: b.shortDescription || "",
    priceFrom: b.priceFrom,
    logoUrl: b.logoUrl,
    review: null,
    badges: [],
    popularServices: [],
    phoneNumber: null,
    isOpenNow: false,
    isVerified: false,
    ownershipStatus: b.ownershipStatus ?? b.ownership_status ?? null,
    visibleServicesCount: b.visibleServicesCount ?? b.visible_services_count ?? 0,
  };
}

const Home = () => {
  const { t, lang } = useTranslation();
  const [businesses, setBusinesses] = useState([]);
  const jsonLd = useMemo(
    () => [buildOrganizationSchema(), buildWebsiteSchema()],
    []
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetchBusinesses({ limit: 12 });
        if (cancelled) return;
        const items = (res?.data || []).map(toCardItem);
        setBusinesses(items);
      } catch (err) {
        if (!cancelled) setBusinesses([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <MainContainer>
      <PageHead
        title={t("seo.homeTitle")}
        description={t("seo.homeDescription")}
        canonical={`/${lang}`}
        jsonLd={jsonLd}
      />
      {/* Figma order: Hero → Features → Categories → Discovery (×3) → How it works → PromBiz → Testimonials → Insights → CTA */}
      <LandingHero />
      <LandingFeatures />
      <LandingCategories />
      <LandingDiscovery items={businesses} />
      <LandingHowItWorks />
      <LandingPromBiz />
      <LandingTestimonials />
      <LandingInsights />
      {/* "Ready to Grow" CTA is rendered globally by Footer */}
    </MainContainer>
  );
};

export default Home;
